@let integration = integration$ | async;
@let connection = connection$ | async;
<glxy-page [pagePadding]="false">
  <ng-template #loadingSpinner>
    <glxy-loading-spinner></glxy-loading-spinner>
  </ng-template>
  <ng-container *ngIf="pageData$ | async as data; else loadingSpinner">
    <glxy-page-toolbar>
      <glxy-page-nav>
        <glxy-page-nav-button
          *ngIf="namespace$ | async as namespace"
          [previousPageTitle]="'INTEGRATION_PAGE.PLATFORM_INTEGRATION' | translate"
          [historyBackButtonTitle]="'INTEGRATION_PAGE.PLATFORM_INTEGRATION' | translate"
          [previousPageUrl]="navigateBack()"
        ></glxy-page-nav-button>
      </glxy-page-nav>
      <glxy-page-title>{{ 'INTEGRATION_PAGE.PLATFORM_INTEGRATION' | translate }}</glxy-page-title>
    </glxy-page-toolbar>
    <div class="container">
      <div class="content">
        <div class="header">
          <div class="left-space"></div>
          <div class="header-row">
            <div class="logo-title-row">
              <div class="logo-container">
                <div class="logo">
                  <img [src]="data.cardDetail?.integration.logo" alt="Logo" />
                </div>
              </div>

              <div class="title-description-column">
                <div class="title-badge-row">
                  <div class="header-title">{{ data.cardDetail?.integration?.displayName }}</div>
                  <div class="connection-badge-container">
                    <glxy-badge
                      [color]="'green'"
                      *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'CONNECTED'"
                    >
                      {{ 'INTEGRATION_CARD.CONNECTED' | translate }}
                    </glxy-badge>
                    <glxy-badge
                      [color]="'red'"
                      *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED'"
                    >
                      {{ 'INTEGRATION_CARD.DISCONNECTED' | translate }}
                    </glxy-badge>
                    <glxy-badge
                      [color]="'yellow'"
                      *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'PRECONNECTED'"
                    >
                      {{ 'INTEGRATION_CARD.CONNECTION_PENDING' | translate }}
                    </glxy-badge>
                  </div>
                </div>
                <div class="header-description">{{ data.cardDetail?.integration.description }}</div>
              </div>
            </div>
            <div class="button-badge-container">
              <div class="connection-badge-container-mobile">
                <glxy-badge
                  [color]="'green'"
                  *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'CONNECTED'"
                >
                  {{ 'INTEGRATION_CARD.CONNECTED' | translate }}
                </glxy-badge>
                <glxy-badge
                  [color]="'red'"
                  *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED'"
                >
                  {{ 'INTEGRATION_CARD.DISCONNECTED' | translate }}
                </glxy-badge>
                <glxy-badge
                  [color]="'yellow'"
                  *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'PRECONNECTED'"
                >
                  {{ 'INTEGRATION_CARD.CONNECTION_PENDING' | translate }}
                </glxy-badge>
              </div>
              <div>
                <button
                  mat-stroked-button
                  color="warn"
                  *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED'"
                  (click)="openWarnModal(data)"
                >
                  {{ 'INTEGRATION_CARD.CANCEL_CONNECTION' | translate }}
                </button>
                <button
                  mat-flat-button
                  class="reconnect-btn"
                  color="primary"
                  *ngIf="
                    statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED' &&
                    data.cardDetail?.integration?.connectionMethod !== connectionMethods.VENDOR_MANAGED &&
                    data.cardDetail?.integration?.connectionMethod !== connectionMethods.APIKEY
                  "
                  (click)="reconnectConnection(data)"
                >
                  {{ 'INTEGRATION_CARD.RECONNECT' | translate }}
                </button>
                <button
                  mat-stroked-button
                  color="warn"
                  *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'CONNECTED'"
                  (click)="openWarnModal(data)"
                >
                  {{ 'INTEGRATION_CARD.DISCONNECT' | translate }}
                </button>
                <div *ngIf="statusConversion(data.cardDetail?.connection?.status) === 'PRECONNECTED'">
                  <ng-container
                    *ngIf="
                      data.cardDetail?.integration?.connectionMethod === connectionMethods.VENDOR_MANAGED;
                      else CancelRequest
                    "
                  >
                    <button
                      mat-stroked-button
                      color="warn"
                      (click)="disconnectConnection(data)"
                      class="button-with-space"
                    >
                      {{ 'INTEGRATION_CARD.CANCEL_CONNECTION_REQUEST' | translate }}
                    </button>
                  </ng-container>
                  <ng-template #CancelRequest>
                    @if (data.cardDetail?.integration?.connectionMethod === connectionMethods.APIKEY) {
                      <button
                        mat-stroked-button
                        color="warn"
                        (click)="disconnectConnection(data)"
                        class="button-with-space"
                      >
                        {{ 'INTEGRATION_CARD.DISCONNECT' | translate }}
                      </button>
                    } @else {
                      <button
                        mat-stroked-button
                        color="basic"
                        (click)="disconnectConnection(data)"
                        class="button-with-space"
                      >
                        {{ 'INTEGRATION_CARD.CANCEL' | translate }}
                      </button>
                      <button
                        mat-flat-button
                        color="primary"
                        *ngIf="data.cardDetail?.integration?.connectionMethod !== connectionMethods.VENDOR_MANAGED"
                        (click)="reconnectConnection(data)"
                      >
                        {{ 'INTEGRATION_CARD.RESUME_CONNECTION' | translate }}
                      </button>
                    }
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div class="right-space"></div>
        </div>
        <div class="line-divider">
          <mat-divider></mat-divider>
        </div>
        <div class="body-container">
          <div class="left-space"></div>
          <div class="body-content">
            <div class="warning-container">
              <glxy-alert
                *ngIf="
                  statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED' &&
                  (data.cardDetail?.integration?.connectionMethod === connectionMethods.VENDOR_MANAGED ||
                    data.cardDetail?.integration?.connectionMethod === connectionMethods.APIKEY)
                "
                type="error"
              >
                <span
                  [innerHTML]="
                    'INTEGRATION_CARD.DISCONNECT_WARNING_PROBLEM_VENDOR_MANAGED'
                      | translate: { title: data.cardDetail?.integration?.displayName }
                  "
                ></span>
              </glxy-alert>
              <glxy-alert
                *ngIf="
                  statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED' &&
                  data.cardDetail?.integration?.connectionMethod !== connectionMethods.VENDOR_MANAGED &&
                  data.cardDetail?.integration?.connectionMethod !== connectionMethods.APIKEY &&
                  data.cardDetail?.connection?.connectionMessages?.length < 0
                "
                type="error"
              >
                <span
                  [innerHTML]="
                    'INTEGRATION_CARD.DISCONNECT_WARNING_PROBLEM'
                      | translate: { title: data.cardDetail?.integration?.displayName }
                  "
                ></span>
              </glxy-alert>
              <glxy-alert
                *ngIf="
                  statusConversion(data.cardDetail?.connection?.status) === 'DISCONNECTED' &&
                  data.cardDetail?.connection?.connectionMessages?.length > 0
                "
                type="warning"
                [showAction]="true"
                actionTitle="{{ 'INTEGRATION_CARD.VERIFY_YOUR_BUSINESS' | translate }}"
                (actionClick)="navigateToAction(data.cardDetail?.connection?.connectionMessages[0]?.ctaUrl)"
              >
                <div [innerHTML]="data.cardDetail?.connection?.connectionMessages[0]?.message"></div>
              </glxy-alert>
              <glxy-alert
                *ngIf="
                  statusConversion(data.cardDetail?.connection?.status) === 'PRECONNECTED' &&
                  !data.cardDetail?.integration?.instructions?.fields?.length
                "
                type="info"
              >
                <span [innerHTML]="configPreconnectMessage(data.cardDetail)"></span>
              </glxy-alert>
            </div>
            @if (
              (integration?.instructions && connection?.status === connectionStatus.PRECONNECTED) ||
              (integration?.instructions &&
                data.cardDetail?.integration?.connectionMethod === connectionMethods.OAUTH2 &&
                connection?.status === connectionStatus.CONNECTED)
            ) {
              <platform-integration-instructions
                [instructions]="integration?.instructions"
                [integration]="integration"
                [connection]="connection"
              ></platform-integration-instructions>
            }
            <h3 class="title">{{ 'CONFIG_PAGE.ACCOUNT_DETAILS' | translate }}</h3>
            <div class="account-details">
              <platform-integration-account-details
                [accountDetails]="accountDetails$ | async"
              ></platform-integration-account-details>
            </div>

            <div class="content" *ngIf="displaySettings">
              <ng-container *ngIf="data.cardDetail?.integration?.connectionMethod !== connectionMethods.LEGACY_OAUTH">
                <div class="line-divider">
                  <mat-divider></mat-divider>
                </div>
                <h3 class="title settings-title">Settings</h3>
              </ng-container>
              <platform-integration-sync-settings
                [integrationType]="data.cardDetail?.integration?.integrationType"
                [pageData]="data"
                (locationSaved)="refreshConnection()"
              ></platform-integration-sync-settings>
            </div>
            <ng-container *ngIf="data.cardDetail?.integration?.additionalInfo?.resources?.length">
              <div class="line-divider">
                <mat-divider></mat-divider>
              </div>
              <h3 class="title">{{ 'CONFIG_PAGE.RESOURCES' | translate }}</h3>
              <platform-integration-resources
                [resources]="data.cardDetail.integration.additionalInfo.resources"
              ></platform-integration-resources>
            </ng-container>
          </div>

          <div class="right-space"></div>
        </div>
      </div>
    </div>
  </ng-container>
</glxy-page>
